import React, {useState, useEffect} from 'react';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import {Bundle, BundleVersion, SortDirection, Pageable, PaginationSettings} from '@deviceinsight/ng-ui-api-client';
import '@deviceinsight/ng-ui-api-client';
import {SelectWithSearch, Reactable} from '@deviceinsight/ng-ui-components';
import {fetchAllReleasedVersions} from '../../../api/updateJobsApi';
import {ADMIN_CREATE_TEST_IDS} from '../consts';
import {JobVariant} from '../types';
import versionColumnDefs from '../columnDefs/versionColumnDefs';
import './JobVariant.less';

type Props = {
	bundles: Bundle[];
	formData: JobVariant;
	setFormData: (arg0: JobVariant) => void;
};

type Item = {
	type: 'item';
	value: string;
	label: string;
};

const INITIAL_PAGINATION_SETTINGS: PaginationSettings = {
	page: 0,
	size: 5,
	sort: {
		property: 'createdAt',
		direction: 'DESC'
	}
};

const JobVariantForm = ({formData, setFormData, bundles}: Props) => {
	const [versions, setVersions] = useState<Pageable<BundleVersion> | null | undefined>(undefined);
	const [paginationSettings, setPaginationSettings] = useState<PaginationSettings>(INITIAL_PAGINATION_SETTINGS);
	const columnDefs = versionColumnDefs(formData.version, (version) => {
		setFormData({...formData, version});
	});
	useEffect(() => {
		if (formData.bundle) {
			fetchAllReleasedVersions(formData.bundle.value, paginationSettings).then(setVersions);
		} else {
			setVersions(undefined);
		}
	}, [formData, paginationSettings]);
	return (
		<div className="di job-variant" data-testid={`${ADMIN_CREATE_TEST_IDS.JOB_VARIANT}${formData.key}`}>
			<div data-testid={ADMIN_CREATE_TEST_IDS.BUNDLE_SELECT} className="field bundle-select">
				<label>
					<Trans i18nKey="updatejobs.create.bundle">Bundle</Trans>
				</label>
				<SelectWithSearch
					data-testid="create-job-select-bundle"
					clearable
					options={
						bundles.map((b) => ({
							value: b.id,
							label: b.name
						})) as Item[]
					}
					onChange={(value) => {
						setFormData({...formData, bundle: value, version: undefined});
					}}
					value={formData.bundle as Item}
				/>
			</div>
			{versions && (
				<div>
					<Reactable
						isLoading={false}
						uniqueItemKey={(version) => version.id}
						columnDefs={columnDefs}
						paginationSettings={paginationSettings}
						onChangePage={(page) => setPaginationSettings({...paginationSettings, page})}
						onSort={(property: string, direction: SortDirection) =>
							setPaginationSettings({
								...paginationSettings,
								sort: {
									property,
									direction
								}
							})
						}
						pageable={versions}
					/>
				</div>
			)}
		</div>
	);
};

export default JobVariantForm;
